// Helpers de telefone canonicos (tolerantes ao 9o digito BR) vem de
// @goodfellas/phone-identity/normalize — subpath puro, sem mongodb.
export { isEqualWithNinthDigit } from '@goodfellas/phone-identity/normalize'

export const parseJwt = (token: string) => {
  try {
    const base64Url = token.split('.')[1] // Get the payload part
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/') // Convert URL-safe Base64 to standard
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join(''),
    )

    return JSON.parse(jsonPayload)
  } catch (error) {
    console.error('Invalid JWT', error)
    return null
  }
}
